import { render, staticRenderFns } from "./addMenuSon.vue?vue&type=template&id=4a32c495&scoped=true&"
import script from "./addMenuSon.vue?vue&type=script&lang=js&"
export * from "./addMenuSon.vue?vue&type=script&lang=js&"
import style0 from "./addMenuSon.vue?vue&type=style&index=0&id=4a32c495&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a32c495",
  null
  
)

component.options.__file = "addMenuSon.vue"
export default component.exports